export default __webpack_public_path__ + "static/media/phone-mockup.2aefb98d.svg";